import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { allapiAction } from "../../Redux/common/action";
import { URL } from "../../Redux/common/url";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import "./BlogListpub.css"; // make sure to import css

function BlogListpub() {
  const PLACEHOLDER = "/mnt/data/9cd2fa80-541b-4fcc-9669-6ccc699b9edd.png"; // uploaded file fallback

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const blog_list = useSelector((state) =>
    state?.allapi?.blog_list ? state?.allapi?.blog_list : {}
  );
  const get_blog_category_list = useSelector((state) =>
    state?.allapi?.get_blog_category_list
      ? state?.allapi?.get_blog_category_list
      : []
  );
  const get_recent_blog_list = useSelector((state) =>
    state?.allapi?.get_recent_blog_list
      ? state?.allapi?.get_recent_blog_list
      : []
  );

  useEffect(() => {
    dispatch(allapiAction.getBlogListPub(1));
    dispatch(allapiAction.getrectentBlog({}));
  }, [dispatch]);

  // helper to get correct image path (recent posts or blog post)
  const imageUrl = (img) => {
    if (!img) return PLACEHOLDER;
    // some APIs return `feature_image`, some return `image` or full URL already
    if (img?.startsWith?.("http")) return img;
    return URL?.API_BASE_URL + (img || "");
  };

  return (
    <div className="blog-page">
     <div className="fall-flowers">
  <div className="flower" style={{ left: "10%" }}></div>
  <div className="flower" style={{ left: "30%", animationDelay: "1s" }}></div>
  <div className="flower" style={{ left: "50%", animationDelay: "2s" }}></div>
  <div className="flower" style={{ left: "70%", animationDelay: "0.6s" }}></div>
  <div className="flower" style={{ left: "85%", animationDelay: "1.8s" }}></div>
</div>


      <div className="page-title">
        <div className="container-fluid">
          <div className="page-caption text-center">
            <h1>Job In Grid</h1>
          </div>
        </div>
      </div>

      {/* decorative animated petals container */}
      <div className="petals-overlay" aria-hidden="true">
        <div className="petal petal-1" />
        <div className="petal petal-2" />
        <div className="petal petal-3" />
        <div className="petal petal-4" />
        <div className="glitter" />
      </div>

      <div className="container mt-5">
        <div className="row">
          {/* main blog cards */}
          <div className="col-lg-8 col-md-7">
            <div className="row">
              {blog_list?.docs &&
                blog_list?.docs?.map((data, i) => (
                  <div className="col-md-6 col-12 mb-4" key={i}>
                    <div
                      className="giva-blog-card shadow-sm rounded-4 p-0"
                      onClick={() => navigate("/blog-details/" + data?.slug)}
                    >
                      <div className="giva-img-wrapper">
                        <img
                          src={imageUrl(data?.feature_image || data?.image)}
                          alt={data?.title}
                          className="giva-card-img"
                        />
                      </div>

                      <div className="p-3">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <span className="giva-tag">
                            {data?.blog_category_name || "General"}
                          </span>
                          <span className="small text-muted">
                            {moment(data?.createdAt).format("MMM DD, YYYY")}
                          </span>
                        </div>

                        <h5 className="fw-bold mt-0 giva-card-title">
                          {data?.title}
                        </h5>

                        <p className="text-secondary small giva-desc">
                          {data?.short_description}
                        </p>

                        <div className="d-flex justify-content-between align-items-center mt-3">
                          <button
                            className="btn btn-outline-primary btn-sm"
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate("/blog-details/" + data?.slug);
                            }}
                          >
                            Read More
                          </button>
                          <span className="text-muted small">
                            {data?.reading_time || "2 min read"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>

          {/* sidebar */}
          <div className="col-lg-4 col-md-5">
            <div className="sidebar">
              <div className="widget mb-4">
                <h6 className="fw-bold border-bottom pb-2">Categories</h6>
                {get_blog_category_list &&
                  get_blog_category_list.map((c, i) => (
                    <p
                      className="sidebar-link"
                      key={i}
                      onClick={() => navigate("/blogs/category/" + c?.slug)}
                    >
                      {c?.name}
                    </p>
                  ))}
              </div>

              <div className="widget">
                <h6 className="fw-bold border-bottom pb-2">Recent Posts</h6>

                {get_recent_blog_list &&
                  get_recent_blog_list.map((item, index) => (
                    <div
                      className="recent-post d-flex align-items-center mb-3 pointer"
                      key={index}
                      onClick={() => navigate("/blog-details/" + item?.slug)}
                    >
                      <img
                        src={imageUrl(item?.feature_image || item?.image)}
                        alt={item?.title}
                        className="recent-img"
                      />
                      <div className="ms-2">
                        <p className="recent-title mb-1">{item?.title}</p>
                        <span className="recent-date">
                          {moment(item?.createdAt).format("MMM DD, YYYY")}
                        </span>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>

        {/* optional: pagination placeholder */}
        <div className="row mt-4">
          <div className="col-12 d-flex justify-content-center">
            {/* integrate your pagination component if any */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BlogListpub;
